import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingService } from '../../../core/services/loading.service';

@Component({
  selector: 'app-loader',
  imports: [CommonModule],
  template: `
    @if (loadingService.isLoading()) {
      <div class="loader-overlay">
        <div class="loader-content">
          <div class="spinner">
            <div class="inner-circle"></div>
          </div>
          <p class="loader-text">Loading...</p>
        </div>
      </div>
    }
  `,
  styles: [`
    .loader-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(15, 15, 35, 0.7);
      backdrop-filter: blur(8px);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
      animation: fadeIn 0.3s ease;
    }

    .loader-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1.5rem;
    }

    .spinner {
      width: 64px;
      height: 64px;
      border: 3px solid rgba(255, 255, 255, 0.1);
      border-top: 3px solid #6366f1;
      border-right: 3px solid #a855f7;
      border-radius: 50%;
      position: relative;
      animation: spin 1s linear infinite;
      box-shadow: 0 0 20px rgba(99, 102, 241, 0.2);
    }

    .inner-circle {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 12px;
      height: 12px;
      background: #fff;
      border-radius: 50%;
      box-shadow: 0 0 15px #fff;
    }

    .loader-text {
      color: #fff;
      font-weight: 500;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      font-size: 0.875rem;
      animation: pulse 1.5s ease-in-out infinite;
    }

    @keyframes spin {
      to { transform: rotate(360deg); }
    }

    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }

    @keyframes pulse {
      0%, 100% { opacity: 0.5; transform: scale(0.95); }
      50% { opacity: 1; transform: scale(1); }
    }
  `]
})
export class LoaderComponent {
  loadingService = inject(LoadingService);
}
